module.exports = __webpack_public_path__ + "static/media/Login-BG.9d80dbd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Login-BG.jpg
// module id = 1438
// module chunks = 0